import './App.css';
import { useState, useEffect } from 'react'
import Button from './components/Button'
import Palette from './components/Palette'
import modelWrapper from './models/wrapper'
import modelWrapperTf from './models/wrapperTf'
import rawFamilyModel from './models/family'
import rawNextModel from './models/next'
import ColorEntity from './components/entities/Color'
import FamilyEntity from './components/entities/Family'
import chroma from 'chroma-js'
import randomNamer from './components/utilities/randomNamer';
import { encodePalette } from './components/utilities/palette';
import { ReactComponent as DuplicateIcon } from './components/icons/duplicate.svg'
import { ReactComponent as TrashIcon } from './components/icons/trash.svg'
import ReactGA from 'react-ga';
import { ChromePicker } from 'react-color';

import BezierEditor from 'bezier-easing-editor';
import BezierEasing from 'bezier-easing';

import { Route, useLocation } from 'react-router-dom'
import NavLeft from './components/NavLeft'
import NavRight from './components/NavRight'
import Context from './components/Context'
import Code from './components/Code'
import Privacy from './components/Privacy.js'
import Training from './components/Training'
import Masterclass from './components/Masterclass';
import Dropdown from './components/Dropdown'
import ModelSelect from './components/ModelSelect'

import Luminosity from './components/charts/Luminosity';
import Chroma from './components/charts/Chroma';
import Hue from './components/charts/Hue';
import BlackContrast from './components/charts/BlackContrast';
import WhiteContrast from './components/charts/WhiteContrast';
import PairContrast from './components/charts/PairContrast';

import groupedPresets from './components/entities/presets'

import { Chart } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import './chartjs-plugin-dragdata/index.js';
Chart.register(annotationPlugin);

if(window.location.origin === 'https://tailwind.ink' || window.location.origin === 'https://www.tailwind.ink'){
  ReactGA.initialize('UA-179178286-1');
} else {
  ReactGA.initialize('UA-179178286-2');
}

const familyModel = modelWrapper(rawFamilyModel);
const nextModel = modelWrapper(rawNextModel);

const initialPalete = createInitialPalette('fuk');

function createInitialPalette(a) {
  const inspirationColor = '#00A1FF';
  let newPalette = [];

  let nextColor = nextModel(inspirationColor);

  for(let i = 0; i < 10; i++) {
    let newFamily = familyModel(nextColor.colors[i].hex, i);
    newFamily.pickedColor = nextColor.colors[i].hex;

    newFamily.updateGradient();

    newPalette.push(newFamily);
  }

  newPalette.map((family, index) => {
    family.datasetIndex = parseInt(index);
    return family
  });

  return newPalette;
}

function usePageViews() {
  let location = useLocation();
  useEffect(() => {
    ReactGA.pageview(location.pathname);
  }, [location]);
}

function App() {
  const [zoom, setZoom] = useState({
    x: {
      active: false,
      min: 0,
      max: 9,
      index: null
    }
  });

  const [palette, setPalette] = useState(initialPalete);
  const [paletteColor, setPaletteColor] = useState('#00A1FF');
  const [info, setInfo] = useState('');
  const [presetSelected, setPresetSelected] = useState('New');
  const [presets, setPresets] = useState(JSON.parse(localStorage.getItem('presets')) || groupedPresets);
  const [familyId, setFamilyId] = useState(9);
  const [chartsEl, setChartsEl] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [familyModelTf, setFamilyModelTf] = useState();
  const [paletteHasBeenModified, setPaletteHasBeenModified] = useState(false);
  const [forcePaletteColor, setForcePaletteColor] = useState(false);
  const [paletteModel, setPaletteModel] = useState();
  const [contrastModel, setContrastModel] = useState('wcag');
  const UrlCodedPalette = new URLSearchParams(useLocation().search).get('p');
  const [leavingUrlPalette, setLeavingUrlPalette] = useState(UrlCodedPalette === null);

  usePageViews();

  useEffect(() => {
    modelWrapperTf().then((model) => {
      setFamilyModelTf(() => model);
      setIsLoading(false)
    });

    const storedPalette = localStorage.getItem('palette');
    if(storedPalette) decodePalette(storedPalette);

    const persistedPresets = JSON.parse(localStorage.getItem('presets'));
    setPresets(persistedPresets);

    const persistedPresetSelected = localStorage.getItem('presetSelected');
    if (persistedPresetSelected) setPresetSelected(persistedPresetSelected);
  }, []);

  useEffect(() => {
    let encodedPalette = encodePalette(palette);

    presets[1].options.map((preset) => {
      if(preset.value === presetSelected) {
        preset.data = encodedPalette
      }
      return palette;
    });

    setPresets(presets); // Do not remove!! needed for first visitor with empty localStorage!
    localStorage.setItem('presets', JSON.stringify(presets));
    localStorage.setItem('palette', encodedPalette);

  },[presets, palette, presetSelected]);

  useEffect(() => {
    localStorage.setItem('presetSelected', presetSelected);
  },[presetSelected]);

  useEffect(() => {
    decodePalette(UrlCodedPalette);

    if(UrlCodedPalette) {
      setPaletteHasBeenModified(true);
      setPresetSelected('New')
    }
  }, [UrlCodedPalette]);

  function deleteFamily(id) {
    let newPalette = [...palette].filter((family) => family.id !== id);

    newPalette.map((family, index) => {
      family.datasetIndex = index;
      return family
    });

    setPalette(newPalette);
    setPaletteHasBeenModified(true);

    ReactGA.event({category: 'button', action: 'delete family'});
  }

  function addFamily() {
    const inspirationColor = palette[palette.length - 1].colors[5].hex;
    let options = {contrastModel: contrastModel};
    const nextColor = nextModel(inspirationColor, options).colors[1].hex;

    let newFamily = familyModel(nextColor, familyId + 1, options);
    newFamily.pickedColor = nextColor;

    newFamily.updateGradient();
    if(zoom.x.active) newFamily.updateZoomGradient(zoom.x.index);

    let newPalette = [...palette, newFamily].map((family, index) => {
      family.datasetIndex = parseInt(index);
      return family
    });

    setPalette(newPalette);
    setPaletteHasBeenModified(true);
    setFamilyId(familyId + 1);

    ReactGA.event({category: 'button', action: 'add family'});
  }

  const onLuminosityDrag = (e, datasetIndex, index, value) => {
    let color = new ColorEntity();
    color.hidrate(palette[datasetIndex].colors[index]);

    let newPalette = [...palette];

    newPalette[datasetIndex].colors[index] = color.setLuminosity(value);
    newPalette[datasetIndex].hasBeenDragged = true;
    newPalette[datasetIndex].update({contrastModel: contrastModel});
    setPalette(newPalette);
  };

  const onChromaDrag = (e, datasetIndex, index, value) => {
    if(value < 0.1) value = 0.1;

    let color = new ColorEntity();
    color.hidrate(palette[datasetIndex].colors[index]);

    let newPalette = [...palette];

    newPalette[datasetIndex].colors[index] = color.setChroma(value);
    newPalette[datasetIndex].hasBeenDragged = true;
    newPalette[datasetIndex].update({contrastModel: contrastModel});

    setPalette(newPalette);
  };

  const onHueDrag = (e, datasetIndex, index, value) => {
    if(value === 360) value = 359.9999;

    let color = new ColorEntity();
    color.hidrate(palette[datasetIndex].colors[index]);

    let newPalette = [...palette];

    newPalette[datasetIndex].colors[index] = color.setHue(value);
    newPalette[datasetIndex].hasBeenDragged = true;
    newPalette[datasetIndex].update({contrastModel: contrastModel});

    setPalette(newPalette);
  };

  const onResize = (width) => {
    let newPalette = [...palette];

    newPalette.forEach((family) => {
      family.updateGradient(width)
    });
    if(zoom.x.active) newPalette.forEach(family => family.updateZoomGradient(zoom.x.index));

    setPalette(newPalette);
  };

  const onHorizontalZoomClick = (index) => {
    let active = !zoom.x.active;
    if(zoom.x.index !== index) active = true;

    setZoom({
      x: {
          active: active,
          min: active  ? index - 1 : 0,
          max: active ? index + 1 : 9,
          index: index
        }
    });

    let newPalette = [...palette];

    if(active) {
      palette.forEach(family => family.updateZoomGradient(index));
    } else {
      palette.forEach(family => family.updateGradient());
    }

    setPalette(newPalette)

    ReactGA.event({category: 'button', action: 'horizontal zoom', label: index});
  };

  const onSolo = (familyId) => {
    let newPalette = [...palette];

    newPalette.map((family) => {
      return family.id === familyId && !family.solo ? family.solo = true : family.solo = false;
    });

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'solo', label: familyId});
  };

  const chartsCallback = (newChart) => {
    if(!newChart) {
      setChartsEl([]);
      return;
    }
    let charts = chartsEl;
    charts[newChart.id] = newChart;
    setChartsEl(charts);
  };

  function onMouseEnterColor(color) {
    openTooltip(color)
  }

  function onMouseLeaveColor(color) {
    closeTooltip(color)
  }

  function openTooltip(color) {
    if(zoom.x.active) return;

    chartsEl.forEach((chart) => {
        chart.tooltip.setActiveElements([
          {
            datasetIndex: palette.filter(family => family.id === color.familyIndex)[0].datasetIndex,
            index: color.index,
          },
        ],
        {
          x: (chart.chartArea.left + chart.chartArea.right) / 2,
          y: (chart.chartArea.top + chart.chartArea.bottom) / 2,
        });

      chart.update();
    })
  }

  function closeTooltip() {
    chartsEl.forEach((chart) => {
      chart.tooltip.setActiveElements([], {x: 0, y: 0});
      chart.update();
    })
  }

  function convertPaletteToLinkData() {
    return window.location.origin + '?p=' + encodePalette(palette);
  }

  function decodePalette(code) {
    if(!code) return null;

    let colorsCode = code.split('.')[1];
    let familiesCount = parseInt(code.split('.')[0]);
    let carrier = 0;
    let output = [];

    if(colorsCode === undefined || familiesCount === 0 || isNaN(familiesCount) || colorsCode.length/familiesCount !== 60) return; // Validate code integrity

    for(let familyIndex = 0; familyIndex < familiesCount; familyIndex++){
      output[familyIndex] = new FamilyEntity(familyIndex, '', []);

      for(let colorIndex = 0; colorIndex < 10; colorIndex++){
        let hex = '#' + colorsCode.substring(carrier, carrier + 6);
        output[familyIndex].colors[colorIndex] = new ColorEntity(familyIndex, colorIndex, hex);
        carrier += 6;
      }

      output[familyIndex].datasetIndex = familyIndex;
      output[familyIndex].pickedColor = output[familyIndex].colors[5].hex;
      if(UrlCodedPalette) output[familyIndex].hasBeenDragged = true;
      output[familyIndex].update({contrastModel: contrastModel});
    }

    setFamilyId(familiesCount);
    setPalette(output);

    return output;
  }

  function onColorChange(color, family, model) {
    let newFamily;
    let options = {contrastModel: contrastModel};

    if(model && model.value === 'New' && familyModelTf) {
      newFamily = familyModelTf(color.hex, family.id, options);
    } else {
      newFamily = familyModel(color.hex, family.id, options);
    }

    newFamily.updateGradient();
    if(zoom.x.active) newFamily.updateZoomGradient(zoom.x.index);

    let newPalette = palette.map((fam) => {
      if(fam.id === family.id) {
        newFamily.pickedColor = color.hex;
        newFamily.datasetIndex = fam.datasetIndex;
        newFamily.solo = fam.solo;
        return newFamily;
      }
      return fam;
    });

    if(family.forceColor) {
      let pickedColorLch = chroma(color.hex).lch();
      let shortestDistance = 1000;
      let closestColor = null;
      let distance = null;

      family.colors.forEach((color) => {
        distance = Math.abs(color.lch[0] - pickedColorLch[0]);
        if(distance < shortestDistance) {
          shortestDistance = Math.abs(color.lch[0] - pickedColorLch[0]);
          closestColor = color;
        }
      });

      newPalette[family.datasetIndex].colors[closestColor.index] = new ColorEntity(family.id, closestColor.index, family.pickedColor, pickedColorLch);
      newPalette[family.datasetIndex].forceColor = true;
    }

    setPalette(newPalette);
    setPaletteHasBeenModified(true)
  }

  function onColorChangeForPalette(colorHex) {
    let newPalette = [];
    const nextColor = nextModel(colorHex);

    let familyColorsCount = palette.length < 11 ? palette.length : 10;
    let options = {contrastModel: contrastModel};

    for(let i = 0; i < familyColorsCount; i++) {
      let newFamily;

      if(paletteModel && paletteModel.value === 'New' && familyModelTf) {
        newFamily = familyModelTf(nextColor.colors[i].hex, i, options);
      } else {
        newFamily = familyModel(nextColor.colors[i].hex, i, options);
      }

      newFamily.pickedColor = nextColor.colors[i].hex;

      newFamily.updateGradient();
      if(zoom.x.active) newFamily.updateZoomGradient(zoom.x.index);

      newPalette.push(newFamily);
    }

    newPalette.map((family, index) => {
      family.datasetIndex = parseInt(index);
      return family
    });

    let remainingFamiliesCount = familyColorsCount - palette.length;
    let remainingFamilies = remainingFamiliesCount === 0 ? [] : [...palette].slice(remainingFamiliesCount);

    if(forcePaletteColor) {
      let pickedColorLch = chroma(colorHex).lch();
      let shortestDistance = 10000;
      let closestColor = null;
      let distance = null;
      let familyIndex = 0;

      newPalette.forEach((family, index) => {
        family.colors.forEach((oldColor) => {
          distance = chroma.deltaE(oldColor.hex, colorHex);
          if(distance < shortestDistance) {
            shortestDistance = chroma.deltaE(oldColor.hex, colorHex);
            closestColor = oldColor;
            familyIndex = index;
          }
        });
      });
      newPalette[familyIndex].colors[closestColor.index] = new ColorEntity(familyIndex, closestColor.index, colorHex, pickedColorLch);
      newPalette[familyIndex].forceColor = true;
    }

    setPalette([...newPalette, ...remainingFamilies]);
    setPaletteColor(colorHex)
  }

  function onRecalculateFamily(family) {
    let newPalette = [...palette];

    newPalette[family.datasetIndex].hasBeenDragged = false;

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'enable family picker'});
  }

  function onRecalculatePalette() {
    let newPalette = [...palette];

    newPalette.map(family => family.hasBeenDragged = false);

    setPalette(newPalette);

    setPaletteHasBeenModified(false);

    ReactGA.event({category: 'button', action: 'enable palette picker'});
  }

  function forceColorInFamily(family, force) {
    let pickedColorLch = chroma(family.pickedColor).lch();
    let shortestDistance = 1000;
    let closestColor = null;
    let distance = null;
    let newPalette = [...palette];

    if(force) {
      family.colors.forEach((color) => {
        distance = Math.abs(color.lch[0] - pickedColorLch[0]);
        if(distance < shortestDistance) {
          shortestDistance = Math.abs(color.lch[0] - pickedColorLch[0]);
          closestColor = color;
        }
      });

      newPalette[family.datasetIndex].colors[closestColor.index] = new ColorEntity(family.id, closestColor.index, family.pickedColor, pickedColorLch);
      newPalette[family.datasetIndex].forceColor = true;
    } else {
      newPalette[family.datasetIndex] = familyModel(family.pickedColor, family.id);
      newPalette[family.datasetIndex].pickedColor = family.pickedColor;
      newPalette[family.datasetIndex].datasetIndex = family.datasetIndex;
      newPalette[family.datasetIndex].forceColor = false;
    }

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'force color in family', label: force});
  }

  function forceColorInPalette() {
    let pickedColorLch = chroma(paletteColor).lch();
    let shortestDistance = 10000;
    let closestColor = null;
    let distance = null;
    let familyIndex = 0;
    let newPalette = [...palette];

    if(!forcePaletteColor) {
      newPalette.forEach((family, index) => {
        family.colors.forEach((oldColor) => {
          distance = chroma.deltaE(paletteColor, oldColor.hex);
          if(distance < shortestDistance) {
            shortestDistance = chroma.deltaE(paletteColor, oldColor.hex);
            closestColor = oldColor;
            familyIndex = index;
          }
        });
      });

      newPalette[familyIndex].colors[closestColor.index] = new ColorEntity(familyIndex, closestColor.index, paletteColor, pickedColorLch);
      newPalette[familyIndex].forceColor = true;

    } else {
      newPalette = [...palette].map((family) => {
        if(!family.forceColor) return family;
        console.log(1)

        let newFamily = familyModel(family.pickedColor, family.id);
        newFamily.pickedColor = family.pickedColor;
        newFamily.forceColor = false;

        return newFamily;
      });
    }

    setPalette(newPalette);
    setForcePaletteColor(!forcePaletteColor);

    ReactGA.event({category: 'button', action: 'force color in palette', label: forcePaletteColor});
  }

  function selectPreset(preset) {
    decodePalette(preset.data);

    setPresetSelected(preset.value);
    setLeavingUrlPalette(true)

    ReactGA.event({category: 'button', action: 'select preset', label: preset.value});
  }

  function addPreset() {
    let name = randomNamer();

    if((presets[1].options.length > 0 || presetIsDefault()) && leavingUrlPalette) {
      setPalette(createInitialPalette());
      setFamilyId(9);
    }

    let newPresets = [...presets];

    newPresets[1].options.push({
      value: name,
      label: name,
      data: encodePalette(palette)
    });

    setPresets(newPresets);
    setPresetSelected(name);
    setLeavingUrlPalette(true);
    setPaletteHasBeenModified(false);

    ReactGA.event({category: 'button', action: 'add preset'});
  }

  function duplicatePreset() {
    let name = randomNamer();

    if(presets[0].options.filter(preset => preset.value === presetSelected).length > 0) { // A non user preset will be duplicated
      setPaletteHasBeenModified(true);
      setPalette([...palette].map((family) => {
        family.hasBeenDragged = true;
        return family;
      }))
    }

    let newPresets = [...presets];

    newPresets[1].options.push({
      label: name,
      value: name,
      data: encodePalette(palette)
    });

    setPresets(newPresets);
    setPresetSelected(name);

    ReactGA.event({category: 'button', action: 'duplicate preset'});
  }

  function deletePreset() {
    let newPresets = [...presets];
    let nextPresetSelectedIndex = 0;
    let nextPresetSelected = newPresets[0].options[0];

    newPresets[1].options = newPresets[1].options.filter((preset, index) => {
      nextPresetSelectedIndex = index - 1;
      return preset.value !== presetSelected
    });

    if(nextPresetSelectedIndex >= 0) nextPresetSelected = newPresets[1].options[nextPresetSelectedIndex];
    if(!nextPresetSelected) return;

    setPresets(newPresets);
    setPresetSelected(nextPresetSelected.value);
    decodePalette(nextPresetSelected.data);

    ReactGA.event({category: 'button', action: 'delete preset'});
  }

  function presetIsDefault() {
    return presets[0].options.filter(preset => preset.value === presetSelected).length > 0
  }

  function onAverageHue(family) {
    let sumHues = 0;
    family.colors.forEach(color => sumHues += color.lch[2]);
    let averageHue = sumHues/family.colors.length;

    family.colors.map((color) => {
      color.setHue(averageHue);
      return color;
    });
    family.hasBeenDragged = true;

    family.update({contrastModel: contrastModel});

    let newPalette = [...palette];

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'average hue'});
  }

  function onStandardLuminosity(family, type) {

    //let standardLuminosity = [97, 90, 80, 70, 60, 50, 40, 30, 20, 10];
    //let standardLuminosity = [97.6, 93.5, 88.2, 81.7, 74, 65.1, 55.1, 44.8, 34, 23.1];
    //let standardLuminosity = [97.2, 93, 87.1, 79.2, 69.6, 58.3, 46.4, 34.9, 25.3, 17.1];


    let standardLuminosity = [97, 92.9, 87.5, 80.8, 73.2, 64.9, 55.7, 46.1, 35.9, 24.3]; // APCA middle
    if(type === 'light') standardLuminosity = [97.8, 95.3, 92.1, 87.5, 80.6, 71, 57.5, 43.7, 30.4, 18.3]; // APCA black
    if(type === 'dark') standardLuminosity = [97, 89.8, 79.5, 68.1, 57, 46.4, 36.9, 28.8, 21.8, 14.4]; // APCA light
    if(type === 'str') standardLuminosity = [97, 90.5, 83.6, 76.2, 68.3, 59.6, 50.4, 40.6, 29.6, 15]; // APCA straight

    //let standardLuminosity = curve;
    family.colors.map((color, key) => {
      color.setLuminosity(standardLuminosity[key]);
      return color;
    });
    family.hasBeenDragged = true;

    family.update({contrastModel: contrastModel});

    let newPalette = [...palette];

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'standard luminosity'});
  }

  function onDuplicateFamily(family) {
    let newFamily = new FamilyEntity(familyId + 1);

    family.colors.forEach((color, index) => {
      newFamily.colors.push(new ColorEntity(familyId + 1, index, color.hex))
    });

    newFamily.pickedColor = family.pickedColor;
    newFamily.updateGradient();

    let newPalette = [...palette, newFamily].map((family, index) => {
      family.datasetIndex = parseInt(index);
      return family
    });

    setPalette(newPalette);
    setFamilyId(familyId + 1);

    ReactGA.event({category: 'button', action: 'duplicate family'});
  }

  function onForceHue(family) {
    let hue = chroma(family.pickedColor).lch()[2];

    family.colors.map((color) => {
      color.setHue(hue);
      return color;
    });
    family.hasBeenDragged = true;

    family.update({contrastModel: contrastModel});

    let newPalette = [...palette];

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'force hue'});
  }

  function onSmoothHue(family) {
    family.colors.map((color, key) => {
      if(key < 9 && key > 0) {
        color.setHue((family.colors[key - 1].lch[2] + family.colors[key + 1].lch[2])/2)
      }
      return color;
    });

    family.hasBeenDragged = true;

    family.update({contrastModel: contrastModel});

    let newPalette = [...palette];

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'smooth hue'});
  }

  function onPlusHue(family) {
    family.colors.map((color) => {
        color.setHue(color.lch[2] + 2)

      return color;
    });

    family.hasBeenDragged = true;

    family.update({contrastModel: contrastModel});

    let newPalette = [...palette];

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'plus hue'});
  }

  function onMinusHue(family) {
    family.colors.map((color) => {
      color.setHue(color.lch[2] - 1)

      return color;
    });

    family.hasBeenDragged = true;

    family.update({contrastModel: contrastModel});

    let newPalette = [...palette];

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'plus hue'});
  }

  function onSmoothChroma(family) {
    family.colors.map((color, key) => {
      if(key < 9 && key > 0) {
        color.setChroma((family.colors[key - 1].lch[1] + family.colors[key + 1].lch[1])/2)
      }
      return color;
    });

    family.hasBeenDragged = true;

    family.update({contrastModel: contrastModel});

    let newPalette = [...palette];

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'smooth chroma'});
  }

  function onPlusChroma(family) {
    family.colors.map((color) => {
      color.setChroma(color.lch[1]*1.1);
      return color;
    });

    family.hasBeenDragged = true;

    family.update({contrastModel: contrastModel});

    let newPalette = [...palette];

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'plus chroma'});
  }

  function onMinusChroma(family) {
    family.colors.map((color) => {
      color.setChroma(color.lch[1]*0.9);
      return color;
    });

    family.hasBeenDragged = true;

    family.update({contrastModel: contrastModel});

    let newPalette = [...palette];

    setPalette(newPalette);

    ReactGA.event({category: 'button', action: 'minus chroma'});
  }

  function onPaletteNameChange(e) {
    let newPresets = [...presets];

    newPresets[1].options.map((preset) => {
      if(preset.label === presetSelected) {
        preset.label = e.target.value;
        preset.value = e.target.value;

        return preset;
      }
    });

    setPresetSelected(e.target.value);
    setPresets(newPresets);
  }

  function onPaletteNameBlur(e) {
    if(e.target.value !== '') return;
    let newPresets = [...presets];
    let name = randomNamer();

    newPresets[1].options.map((preset) => {
      if(preset.label === presetSelected) {
        preset.label = name;
        preset.value = name;

        return preset;
      }
    });

    setPresetSelected(name);
    setPresets(newPresets);
  }

  function loadModelFromLocalStorage() {
    modelWrapperTf().then((model) => {
      setFamilyModelTf(() => model);
    });
  }

  function onPaletteModelSelect(model) {
    setPaletteModel(model);

    ReactGA.event({category: 'button', action: 'select palette model', label: model.value});
  }

  function onContrastModelSelect(contrastModel) {
    setContrastModel(contrastModel);
    let newPalette = [...palette];

    newPalette.forEach((family) => {
      family.update({contrastModel: contrastModel})
    });

    setPalette(newPalette);
  }

  if(isLoading) {
    return null;
  }

  function onBezierChange(value) {
    let easing = BezierEasing(value[0],value[1],value[2],value[3]);

    let curve = [100*easing(0.91), 100*easing(0.82), 100*easing(0.73), 100*easing(0.64), 100*easing(0.55), 100*easing(0.46), 100*easing(0.37), 100*easing(0.28), 100*easing(0.19), 100*easing(0.1)];

    onStandardLuminosity(palette[0], curve)
  }



  return (
    <div className='flex flex-col lg:flex-row'>
      <div className='absolute bottom-0 left-1'>{info}</div>
      <div className='border-r xl:h-screen'>
        <NavLeft />
        <div className='overflow-y-auto col-left'>
          <div className='ml-8 mr-10 mt-4'>
            <div className='flex'>
              <div className='w-56'>
                <Dropdown onSelect={selectPreset} presetSelected={presetSelected} presets={presets} />
              </div>
              <Button className='px-3 ml-1 text-sm'
                      onClick={addPreset}
                      type={ ((presets[1].options.length > 0 || presetIsDefault()) && leavingUrlPalette) && 'plus' }>
                {((presets[1].options.length > 0 || presetIsDefault()) && leavingUrlPalette) ? 'Palette' : 'Save'}
              </Button>
              <Button className='px-3 ml-1' onClick={duplicatePreset} info={`Duplicate ${presetSelected} palette`} setInfo={setInfo}>
                <DuplicateIcon/>
              </Button>
              { !presetIsDefault() &&
              <Button className='px-3 ml-1' onClick={deletePreset} info={`Delete ${presetSelected} palette`} setInfo={setInfo}>
                <TrashIcon width='18' height='18'/>
              </Button>
              }
            </div>
            { (presets[1].options.filter(preset => preset.label === presetSelected).length === 1 || presetSelected === 'New') && // It's a user preset
              <div>
                <div className='text-xs text-gray-500 tracking-wider mb-1 mt-3 font-medium select-none'>PALETTE EDITOR</div>
                <div className='flex'>
                  <div className=''>
                    <div className='relative border rounded-b-md' style={{width: '227px'}}>
                      <ChromePicker
                        color={ paletteColor }
                        onChange={(color) => onColorChangeForPalette(color.hex)}
                        onChangeComplete={(color) => ReactGA.event({category: 'button', action: 'color pick for palette', label: color.hex})}
                        disableAlpha={true} />

                      <div className='flex items-center mb-2 ml-4'>
                        <input
                          type='checkbox'
                          checked={forcePaletteColor}
                          onChange={forceColorInPalette}/>
                        <label className='text-xs text-gray-500 ml-1 select-none' onClick={forceColorInPalette}>Force picked color</label>
                      </div>

                      {
                        (palette.filter(family => family.hasBeenDragged === true).length > 0 || paletteHasBeenModified) &&
                        <div className='absolute top-0 w-full flex flex-col h-full justify-center items-center bg-white z-10 bg-opacity-95 rounded-b-md'>
                          <div className='text-xs text-gray-800 text-center mb-3 px-4 select-none'>The color families of this palette has been adjusted individually. <br/> Recalculate palette?</div>
                          <Button onClick={() => onRecalculatePalette()} className='px-2 py-1 bg-white text-xs'>Enable picker</Button>
                        </div>
                      }
                    </div>

                  </div>

                  <div className='ml-2'>
                    <div className='flex flex-col'>
                      <label className='text-sm text-gray-700 font-medium pb-1 select-none'>Name</label>
                      <input type='text' value={presetSelected} onChange={onPaletteNameChange} className='border border-gray-300 w-56 rounded-md px-2 font-medium h-10 text-gray-700' onBlur={onPaletteNameBlur}/>
                    </div>
                    <div className='flex flex-col mt-2'>
                      <label className='text-sm text-gray-700 font-medium pb-1 select-none'>Engine</label>
                      <ModelSelect onModelSelect={onPaletteModelSelect} modelSelected={paletteModel} />
                    </div>
                  </div>

                </div>
              </div>
            }

          </div>

          <div className='text-xs text-gray-500 tracking-wider mt-4 font-medium ml-8 select-none'>COLOR FAMILIES</div>

          <Palette
            palette={palette}
            zoom={zoom}
            onDeleteFamily={deleteFamily}
            onSolo={onSolo}
            className='p-1 pt-0'
            onHorizontalZoomClick={onHorizontalZoomClick}
            onMouseEnterColor={onMouseEnterColor}
            onMouseLeaveColor={onMouseLeaveColor}
            onColorChange={onColorChange}
            onRecalculateFamily={onRecalculateFamily}
            forceColorInFamily={forceColorInFamily}
            onAverageHue={onAverageHue}
            onDuplicateFamily={onDuplicateFamily}
            onStandardLuminosity={onStandardLuminosity}
            onForceHue={onForceHue}
            onSmoothHue={onSmoothHue}
            onSmoothChroma={onSmoothChroma}
            onPlusHue={onPlusHue}
            onMinusHue={onMinusHue}
            onPlusChroma={onPlusChroma}
            onMinusChroma={onMinusChroma}
          />

          <div className='my-4 flex lg:justify-center ml-8 lg:ml-0'>
            { palette.length < 30 &&
            <Button onClick={addFamily} type='plus' className='px-2 py-1 mr-1 text-sm'>Add family</Button>
            }
          </div>
        </div>
      </div>

      <div className='flex flex-col flex-grow h-screen' style={{minWidth: '100px'}}>

        <NavRight convertPaletteToLinkData={convertPaletteToLinkData} />
        <Route exact path='/'>
          <div className='flex flex-col sm:flex-row flex-grow' style={{minWidth: '100px'}}>
            <div className='w-full' style={{minWidth: '100px'}}>
              {/*<BezierEditor defaultValue={[0.1, 0.1, 0.9, 0.9]} onChange={onBezierChange} progress={0.25} />*/}
              <Luminosity
                palette={palette}
                zoom={zoom}
                onDrag={onLuminosityDrag}
                onResize={onResize}
                chartsCallback={chartsCallback} />
              {/*<LuminosityStar*/}
                {/*palette={palette}*/}
                {/*zoom={zoom}*/}
                {/*onDrag={onLuminosityDrag}*/}
                {/*onResize={onResize}*/}
                {/*chartsCallback={chartsCallback} />*/}
              <Chroma
                palette={palette}
                zoom={zoom}
                onDrag={onChromaDrag}
                chartsCallback={chartsCallback} />
              <Hue
                palette={palette}
                zoom={zoom}
                onDrag={onHueDrag}
                chartsCallback={chartsCallback} />
            </div>
            <div className='w-full' style={{minWidth: '100px'}}>
              <select name="contrastModel" onChange={(e) => onContrastModelSelect(e.target.value)} value={contrastModel} className='mt-2 mb-1 ml-9 p-1 text-xs flex focus:outline-none items-center border rounded-md font-medium border-gray-300 text-gray-600 shadow hover:shadow-md transition-shadow duration-150 select-none'>
                <option value='wcag'>WCAG 2.0</option>
                <option value='apca'>APCA</option>
              </select>

              <PairContrast palette={palette} contrastModel={contrastModel} />
              <BlackContrast palette={palette} contrastModel={contrastModel} />
              <WhiteContrast palette={palette} contrastModel={contrastModel} />
            </div>
          </div>
        </Route>
        <Route path='/context'>
          <Context palette={palette} />
        </Route>
        <Route path='/code'>
          <Code palette={palette} />
        </Route>
        <Route path='/training'>
          <Training palette={palette} presets={presets} loadModelFromLocalStorage={loadModelFromLocalStorage}/>
        </Route>
        <Route path='/masterclass'>
          <Masterclass />
        </Route>
        <Route path='/privacy'>
          <Privacy />
        </Route>
      </div>

    </div>
  );
}

export default App;

// presetSelected Vicious Consideration
// palette 1.f7f9fbe3f0fdc5d8fb9eb4f57d8cee6667e9544ade4038c02c269318185e
// presets [{"label":"Default","options":[{"value":"tailwindUi","label":"Tailwind UI","data":"10.f9fafbf4f5f7e5e7ebd2d6dc9fa6b26b72804b5563374151252f3f161e2efdf2f2fde8e8fbd5d5f8b4b4f98080f05252e02424c81e1e9b1c1c771d1dfff8f1feecdcfcd9bdfdba8cff8a4cff5a1fd03801b434038a2c0d73230dfdfdeafdf6b2fce96afaca15e3a008c278039f580a8e4b10723b13633112f3faf7def7ecbcf0da84e1bc31c48d0e9f6e057a55046c4e03543f014737edfafad5f5f6afecef7edce216bdca0694a204748103667205505c014451ebf5ffe1effec3ddfda4cafe76a9fa3f83f81c64f21a56db1e429f233876f0f5ffe5edffcddbfeb4c6fc8da2fb6875f55850ec5145cd42389d362f78f6f5ffedebfedcd7fecabffdac94fa9061f97e3af26c2bd95521b54a1d96fdf2f8fce8f3fad1e8f8b4d9f17eb8e74694d61f69bf125d99154b751a3d"},{"value":"tailwindNew","label":"Tailwind New","data":"19.fafafaf4f4f5e4e4e7d4d4d8a1a1aa71717a52525b3f3f4627272a18181bfff1f2ffe4e6fecdd3fda4affb7185f43f5ee11d48be123c9f1239881337fdf2f8fce7f3fbcfe8f9a8d4f472b6ec4899db2777be185d9d174d831843fdf4fffae8fff5d0fef0abfce879f9d946efc026d3a21caf86198f701a75faf5fff3e8ffe9d5ffd8b4fec084fca855f79333ea7e22ce6b21a8581c87f5f3ffede9feddd6fec4b5fda78bfa8b5cf67c3aed6d28d95b21b64c1d95eef2ffe0e7ffc7d2fea5b4fc818cf86366f14f46e54338ca3730a3312e81eff6ffdbeafebfdbfe93c5fd60a5fa3b82f62563eb1d4ed81e40af1e3a8af0f9ffe0f2febae6fd7dd3fc38bdf80ea5e90284c70369a10759850c4a6eeffdfdd2f7f9aaf0f476e4ec39d0dd14b4c60892a20976840b5e6b0d4f5aecfeffcffafea5f3fc67e8f922d3ee06b6d40891b20e7490155e75164e63f0fdfaccfbf199f6e45eead42dd4bf14b8a60d94880f766e115e59134e4aecfdf5d1fae5a7f3d06ee7b734d39910b981059669047857065f46064e3bf0fdf4dcfce7bbf7d086efac4ade8022c55e16a34a15803d16653414532df7fee7ecfccbd9f99dbef264a3e63584cc1665a30d4d7c0f3f6212365314fefce8fef9c3fef08afde047facc15eab308ca8a04a16207854d0e713f12fffbebfef3c7fde68afcd34dfbbf24f59e0bd97706b4530992400e78350ffff7edffedd5fed7aafdba74fb923cf97316ea580cc2410c9a34127c2d12fef2f2fee2e2fecacafca5a5f87171ef4444dc2626b91c1c991b1b7f1d1d"},{"value":"stripe","label":"Stripe","data":"9.FAFCFCE4E8EEC1C9D0A2ABB78892A26B73855056693C40552B2E442B2E44F5FCFFD9EDFFACCFFC85ACF4758CEC5C66D2414AA6313B84262C62152041EEFDFECFF3FB8ED8E962BDE44D9DCE277FB51C5B921548760F3451082530F2FEEECFF7C991E39652D0803EB574288D60216B4418533A113B340A2627FBF9EAF6E4BAE7C07BDC9742CB7519AD51028933016C2706501A0F361206FEFAEEFCE2C0EFB586E78B5FD7664BB34434912728731620550F1C3B0B14FEF7F4FBE0DDF2AFB3EC798BDC5472BC326398184D73123F560E393B0427FEF7FFF8DDF4E8ADE1D882D9BF62CF9B47B274309557237E3D18672A0D53F8F9FEE7E5FCC6C0E9AE9DDE9B7AD87F58BE5F41994A2D7F36216420144C"},{"value":"ibm","label":"IBM","data":"10.fff1f1ffd7d9ffb3b8ff8389fa4d56da1e28a2191f750e135204082d0709fff0f7ffd6e8ffafd2ff7eb6ee5396d026709f18537409375102242a0a18f6f2ffe8daffd4bbffbe95ffa56eff8a3ffc6929c4491d8b31135e1c0f30edf5ffd0e2ffa6c8ff78a9ff4589ff0f62fe0043ce002d9c001d6c001141e5f6ffbae6ff82cfff33b1ff1192e80072c300539a003a6d012749061727d9fbfb9ef0f03ddbd908bdba009d9a007d79005d5d004144022b30081a1cdefbe6a7f0ba6fdc8c42be6524a1481980380e6027044317022d0d071908f2f4f8dde1e6c1c7cda2a9b0878d966970774d5358343a3f21272a121619f4f4f4e0e0e0c6c6c6a8a8a88d8d8d6f6f6f525252393939262626161616f7f3f2e5e0dfcac5c4ada8a88f8b8b726e6e5651513c3838272525171414"}]},{"label":"User","options":[{"value":"Zesty Mentiond","label":"Zesty Mentiond","data":"4.f7fafce3f1fdc5d9fb9cb6f5798ded6268e7504bda3d38bc2a268d171859f2f7f8d7f0f9bdf6ff99e9ff63c1ea2d82b2266899214f781835560f213afafbfbf3f0f9fae6ffcface4bf80d0a85bbf8c3fa569307f482156291531fcfbfbfaf0f2f4d1e4e7a6c6e077a2cf5283b538628d2a48631d2f3b121a"},{"value":"Vicious Consideration","label":"Vicious Consideration","data":"1.f7f9fbe3f0fdc5d8fb9eb4f57d8cee6667e9544ade4038c02c269318185e"}]}]